module.exports = __webpack_public_path__ + "static/media/paintathon-next-p.4d249e07.jpg";